import createAction from '../actions';
import { getCurrentModal } from './getCurrentModal';

export const REMOVE_MODAL = createAction('REMOVE_MODAL');

export const removeModal = (id) => (dispatch, getState) => {
    const state = getState();
    clearTimeout(state.messageSystem.modals.timerId);

    dispatch({
      type: REMOVE_MODAL,
      meta: { id },
    });

    dispatch(getCurrentModal());
};
